import { Table, TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTable = styled(Table)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '12px',
  padding: '8px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  verticalAlign: 'top',
}));

export const StyledHeaderCell = styled(StyledTableCell)(() => ({
  fontWeight: 600,
}));
